import { ReactNode } from 'react';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useTeamStore } from '@/hooks/useTeamStore';
import { EnumDevice } from '@/types';
import { cn, formatMillionBalance } from '@/utils';

type DefaultProps = {
  content: ReactNode;
};

type MobileVariant = {
  variant: EnumDevice.Mobile;
};

type DesktopVariant = {
  variant: EnumDevice.Desktop;
  teamName: string;
};

type ChangeTacticVariant = {
  variant: 'change-tactic';
  teamName: string;
};

type Props =
  | (DefaultProps & MobileVariant)
  | (DefaultProps & DesktopVariant)
  | (DefaultProps & ChangeTacticVariant);

const TeamFormationWrapper = (props: Props) => {
  const { state } = useTeamStore();
  const { content, variant } = props;
  const { isDesktop, isMobile } = useIsDesktop();
  const balance = state.balance;
  const isDesktopVariant = isDesktop && variant === EnumDevice.Desktop;
  const isChangeTactic = variant === 'change-tactic';

  const yourTeamTitle = (
    <h3 className="text-sm text-gdt-gray-4 uppercase font-medium text-left">
      Armá tu equipo
    </h3>
  );

  const renderContent = () => {
    if (isDesktopVariant) {
      const { teamName } = props;
      return (
        <div className="flex gap-2 items-start justify-between">
          <div className="flex-1">
            {yourTeamTitle}
            <p className="text-lg text-left font-bold text-black hyphens-manual">
              {teamName}
            </p>
          </div>
          {content}
        </div>
      );
    }

    if (isMobile && variant === EnumDevice.Mobile) {
      return (
        <div className="flex gap-2 items-center justify-between bg-white px-5 py-4">
          <div>
            <p className="text-3xs uppercase text-gdt-gray-4 font-medium text-left">
              Disponible
            </p>
            <p className="text-base font-semibold text-left">
              ${formatMillionBalance(balance ?? 0)}
            </p>
          </div>
          {content}
        </div>
      );
    }

    if (isChangeTactic) {
      const { teamName } = props;
      return (
        <div className="flex gap-2 items-start justify-between">
          <div className="pr-20">
            {yourTeamTitle}
            <p className="text-lg text-left font-bold text-black lg:text-[#363546] hyphens-manual">
              {teamName}
            </p>
          </div>
          <div className="bg-gdt-gray-5 h-[50px] w-[1px]" />
          <div className="flex-1">{content}</div>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className={cn('w-full', {
        field__floatingCard: isDesktopVariant || isChangeTactic,
      })}
    >
      {renderContent()}
    </div>
  );
};

export default TeamFormationWrapper;
